import { experienceURL } from '../endpoints';

function ExperienceService( { access_token } ) {
    const fetchWithAuth = function( url, options = {} ) {
        options = {
            ...options,
            headers: {
                ...( options.headers || {} ),
                'authorization': `Bearer ${ access_token }`
            }
        };

        return fetch( url, options );
    };


    const listExperiences = async () => {
        const res = await fetchWithAuth( `${ experienceURL }/services/v1/experience`, {
            headers: {
                'content-type': 'application/json'
            }
        } );

        const json = await res.json();
        return json.experiences;
    };


    return {
        listExperiences
    };
}

export default ExperienceService;

